export const DIAS = [
  { value: "lun", label: "Lun" },
  { value: "mar", label: "Mar" },
  { value: "mie", label: "Mié" },
  { value: "jue", label: "Jue" },
  { value: "vie", label: "Vie" },
  { value: "sab", label: "Sáb" },
  { value: "dom", label: "Dom" },
];

export const CATEGORIAS = {
  fuera_ciudad: "Fuera de la ciudad",
  dentro_ciudad: "Dentro de la ciudad",
  privado: "Privado",
};

export const TIPOS_MODALIDAD = {
  vip: "VIP",
  regular: "Regular",
  privado: "Privado",
};

export const VEHICULOS = { van: "Van", bus: "Bus" };

// Portal de Agencias: el vehículo NO se muestra para Regular ni Privado (confunde --
// "Regular" a veces sale en van, y el privado se arma con el vehículo que Tours NY
// decida según la cantidad de pasajeros, nunca es una elección de la agencia). VIP
// sí muestra el vehículo (la van es parte del producto). La Agenda interna sigue
// usando TIPOS_MODALIDAD/VEHICULOS tal cual, sin este recorte.
export function labelModalidadPortal(modalidad, vehiculo) {
  if (modalidad === "privado") return "Privado - Por solicitud";
  if (modalidad === "regular") return "Regular";
  return `${TIPOS_MODALIDAD[modalidad] || modalidad} · ${VEHICULOS[vehiculo] || vehiculo}`;
}

export const REGLAS_INFANTE = {
  siempre_cuenta: "Siempre cuenta asiento",
  nunca_cuenta: "Nunca cuenta",
  segun_vehiculo: "Según vehículo / modalidad",
};

export const IDIOMAS = { es: "Español", en: "Inglés", combinada: "Español-Inglés" };

// Variante Cataratas del Niágara (PROMPT 48): sin/con crucero en barco. Chip corto
// para lista/detalle/pasajeros/exportaciones, igual patrón que el chip de idioma.
export const VARIANTE_NIAGARA = {
  sin_barco: { label: "SIN BARCO", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  con_barco: { label: "CON BARCO", cls: "bg-cyan-50 text-cyan-700 border-cyan-200" },
};

export const ESTADOS_RESERVA = {
  pendiente: { label: "Pendiente", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  confirmada: { label: "Confirmada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  reprogramada: { label: "Reprogramada", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  cancelada: { label: "Cancelada", cls: "bg-red-50 text-red-700 border-red-200" },
  rechazada: { label: "Rechazada", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

// PROMPT 142: a qué estados puede pasar una reserva desde cada uno. Es un ESPEJO de TRANSICIONES
// en backend/services.py (el que manda es el servidor): sirve para no ofrecer en "Editar reserva"
// estados que el servidor rechazaría. Una cancelada solo vuelve a "confirmada" (reactivarla).
export const TRANSICIONES_RESERVA = {
  pendiente: ["confirmada", "cancelada", "rechazada", "reprogramada"],
  confirmada: ["reprogramada", "cancelada"],
  reprogramada: ["confirmada", "cancelada"],
  cancelada: ["confirmada"],
  rechazada: [],
};

export const CANALES = {
  bokun: "Bokun",
  getyourguide: "GetYourGuide",
  whatsapp: "WhatsApp",
  web: "Web propia",
  web_propia: "Web propia",
  otra_ota: "Otra OTA",
  cliente_directo: "Cliente directo",
  manual: "Manual",
  correo: "Correo",
  agencia: "Agencia",
  carga_masiva: "Carga masiva",
  otro: "Otro",
};

export const TIPO_ENTRADA_AGENCIA = {
  bokun: "Bókun",
  correo_formato: "Correo con formato (OTA)",
  correo_manual: "Correo manual (texto libre)",
};

export const TIPO_ENTRADA_BADGE = {
  bokun: "bg-violet-50 text-violet-700 border-violet-200",
  correo_formato: "bg-sky-50 text-sky-700 border-sky-200",
  correo_manual: "bg-amber-50 text-amber-700 border-amber-200",
};

export const TIPOS_CORREO = {
  reserva_nueva: "Reserva nueva",
  cancelacion: "Cancelación",
  cambio_detalle: "Cambio / reprogramación",
  mensaje_cliente: "Mensaje de cliente",
  gyg_care: "GetYourGuide Care",
  sospechoso_no_reserva: "Sospechoso · no parece una reserva",
};

export const SOLICITUD_ESTADOS = {
  aplicada: { label: "Aplicada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rechazada: { label: "Rechazada (fuera de plazo)", cls: "bg-red-50 text-red-700 border-red-200" },
  pendiente_aprobacion: { label: "Pendiente de aprobación", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  aprobada_aplicada: { label: "Aprobada y aplicada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rechazada_por_operador: { label: "Rechazada por operador", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  derivada_gyg: { label: "Derivada a GetYourGuide", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  pendiente_manual: { label: "Pendiente manual", cls: "bg-amber-50 text-amber-700 border-amber-200" },
};

export const TIPOS_SOLICITUD = {
  cancelacion: "Cancelación",
  reprogramacion: "Reprogramación",
  cambio_pax: "Cambio de pasajeros",
};

export const FUERZA_MAYOR = {
  fallecimiento: "Fallecimiento de familiar",
  vuelo_cancelado: "Vuelo cancelado",
};

export const TIPOS_RESPUESTA = {
  confirmacion_reserva: "Confirmación de reserva",
  confirmacion_cancelacion: "Confirmación de cancelación",
  confirmacion_cambio: "Confirmación de cambio",
  rechazo_fuera_plazo: "Rechazo por fuera de plazo",
  protocolo_gyg: "Protocolo · GetYourGuide",
  respuesta_manual: "Respuesta manual (Acciones)",
};

export const RESPUESTA_ESTADOS = {
  borrador: { label: "Borrador", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  enviada: { label: "Enviada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  descartada: { label: "Descartada", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

// Abreviatura chica del idioma de la reserva (ES/EN), para detectar de un vistazo
// una reserva que quedó mezclada en el idioma equivocado.
export function idiomaAbbr(idioma) {
  return (idioma || "es").toLowerCase() === "en" ? "EN" : "ES";
}

export function paxResumen(r = {}) {
  const partes = [];
  if (r.adultos) partes.push(`${r.adultos} ad`);
  if (r.ninos) partes.push(`${r.ninos} niñ`);
  if (r.infantes) partes.push(`${r.infantes} inf`);
  return partes.join(" · ") || "—";
}

export function diasResumen(dias = []) {
  if (!dias || dias.length === 0) return "—";
  if (dias.length === 7) return "Lun a Dom";
  const map = Object.fromEntries(DIAS.map((d) => [d.value, d.label]));
  return dias.map((d) => map[d] || d).join(", ");
}
